/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IComponentProps, IGridSettings, IImageSettings, getUrlSync } from '@msdyn365-commerce/core';
import { ProductPrice, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
// import { getFallbackImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';
import { Button, getPayloadObject, getTelemetryAttributes, ITelemetryContent, TelemetryConstant, Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
export interface IPopupProps extends IComponentProps<{ product: SimpleProduct | undefined; price: ProductPrice | undefined }> {
    dialogStrings?: {
        goToCartText: string;
        continueShoppingText: string;
        headerItemOneText: string;
        headerItemFormatText: string;
        headerMessageText: string;
        freePriceText: string;
        originalPriceText: string;
        currentPriceText: string;
        miniCartTotalAmountLabel?: string;
        festivalEntryText? : string;
        aedText? : string;
    };

    className: string;
    imageSettings?: IImageSettings;
    gridSettings: IGridSettings | undefined;
    productQuantity: number;
    priceComponent: React.ReactNode;
    navigationUrl?: string;
    modalOpen: boolean | undefined;
    telemetryContent?: ITelemetryContent;
    setModalOpen(newValue: boolean): void;
    products: {
        product: SimpleProduct;
        count: number;
    }[],
    counts?: {[key: number]: number};
    setCounts?: React.Dispatch<React.SetStateAction<{
        [key: number]: number;
    }>>;
    buyboxCallbacks?(newQuantity: number): boolean;
    setButtonLoadingState?(value : boolean): void;
}

export const Popup = (popupProps: IPopupProps) => {
    const {
        dialogStrings,
        className,
        imageSettings,
        // gridSettings,
        data: { product },
        // productQuantity,
        // priceComponent,
        // navigationUrl,
        modalOpen,
        telemetryContent,
        setModalOpen,
        context,
        products,
        counts,
        setCounts,
        buyboxCallbacks,
        setButtonLoadingState
    } = popupProps;
    const resetQuantityInput = (counts: {[key: number]: number}, setCounts: React.Dispatch<React.SetStateAction<{[key: number]: number}>> )=>{
        let resetCount: { [key: number]: number}  = {...counts};
        for (const count in counts) {
            if (counts.hasOwnProperty(count)) {
                resetCount = {
                    ...resetCount,
                    [count]: 0
                }
            }
        }
        setCounts && setCounts(resetCount)
    }
    const closeModal = React.useCallback(() => {
        if(setButtonLoadingState) {
            setButtonLoadingState(false)
        }
        if(buyboxCallbacks){
            buyboxCallbacks(0)
        }
        if(counts && setCounts){
            resetQuantityInput(counts,setCounts)
        }
        setModalOpen(false);
    }, [setModalOpen]);
    if (!dialogStrings || !product) {
        return null;
    }
    const [totalAmount, setTotalAmount] = React.useState(0);
    const payLoad = getPayloadObject('click', telemetryContent!, TelemetryConstant.ContinueShopping);
    const continueShoppingAttribute = getTelemetryAttributes(telemetryContent!, payLoad);
    payLoad.contentAction.etext = TelemetryConstant.ViewBagAndCheckout;
    const viewBagAttribute = getTelemetryAttributes(telemetryContent!, payLoad);

    // const fallbackImageUrl = getFallbackImageUrl(product.ItemId, context.actionContext.requestContext.apiSettings);
    if (imageSettings) {
        imageSettings.cropFocalRegion = true;
    }
    // const quantity = productQuantity !== undefined ? productQuantity : 1;
    // const itemsString =
    //     quantity === 1 ? dialogStrings.headerItemOneText : dialogStrings.headerItemFormatText.replace('{0}', quantity.toString());
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- app configs are of generic type
    // const shouldDisplayUnitOfMeasure =
    //     context.app.config?.unitOfMeasureDisplayType && context.app.config.unitOfMeasureDisplayType !== 'none';

    // const reducedDimensions: string = product.Dimensions
    //     ? product.Dimensions.reduce<string>((str, productDimension) => {
    //           if (productDimension.DimensionValue && productDimension.DimensionValue.Value) {
    //               if (str) {
    //                   return `${str}, ${productDimension.DimensionValue.Value}`;
    //               }

    //               return `${productDimension.DimensionValue.Value}`;
    //           }

    //           return str;
    //       }, '')
    //     : '';

    React.useEffect(() => {
        let total = 0;
        products.length && products.map((item) => {
            total += item.count * item.product.Price;
        });
        setTotalAmount(total);
    },[products])
    /* ZOHAIB | VSI | Customization | Start */

    const getCheckoutPageUrl = (): string => {
        const mycheckoutURL = getUrlSync('checkout', context.actionContext) ?? '';
        return mycheckoutURL
    };

    /* ZOHAIB | VSI | Customization | End */
    return (
        <Modal isOpen={modalOpen} onClosed={closeModal} className={`${className}__dialog`} toggle={closeModal}>
            <ModalHeader toggle={closeModal} className={`${className}__dialog__header`}>
                <span>{dialogStrings.headerMessageText}</span>
            </ModalHeader>
            <ModalBody className={`${className}__dialog__body`}>
            {<h3 className='msc-add-to-cart-festival-event'>
                    {dialogStrings.festivalEntryText}
                </h3>}
                {/* <Image
                    requestContext={context.actionContext.requestContext}
                    className={`${className}__dialog__image`}
                    src={product.PrimaryImageUrl || ''}
                    fallBackSrc={fallbackImageUrl}
                    altText={product.Name}
                    gridSettings={gridSettings || {}}
                    imageSettings={imageSettings}
                    loadFailureBehavior="empty"
                /> */}
                {
                    products.map((item) => (
                        <>
                            <div>
                                <h3 className={`${className}__dialog__product-title`}>{product.Name}</h3>
                            </div>
                            <div>
                                {item.product.Name} : {item.count}
                            </div>
                        </>
                    ))
                }
                {/* {reducedDimensions !== '' ? <div className={`${className}__dialog__product-variants`}>{reducedDimensions}</div> : ''} */}
                {/* {price ? <div className={`${className}__dialog__product-price`}>{priceComponent}</div> : ''} */}
                {/* {product.DefaultUnitOfMeasure && shouldDisplayUnitOfMeasure ? (
                    <div className={`${className}__dialog__product-unitOfMeasure`}>
                        <span>{product.DefaultUnitOfMeasure}</span>
                    </div>
                ) : (
                    ''
                )} */}
    
            </ModalBody>            
            {<div className='msc-add-to-cart-total-amount'>{`${dialogStrings.miniCartTotalAmountLabel}: ${dialogStrings.aedText} ${totalAmount.toFixed(2)}`}</div>}
            <ModalFooter className={`${className}__dialog__footer`}>
                <Button
                    className={`${className}__dialog__go-to-cart`}
                    href={getCheckoutPageUrl()}
                    aria-label={dialogStrings.goToCartText}
                    {...viewBagAttribute}
                >
                    {dialogStrings.goToCartText}
                </Button>
                <Button
                    className={`${className}__dialog__back-to-shopping`}
                    onClick={closeModal}
                    aria-label={dialogStrings.continueShoppingText}
                    {...continueShoppingAttribute}
                >
                    {dialogStrings.continueShoppingText}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default Popup;
